// extracted by mini-css-extract-plugin
export default {"component":"TrustpilotBespoke__component-OW4k","background__dark":"TrustpilotBespoke__background__dark-lPvV","container":"TrustpilotBespoke__container-GVw_"};